module.exports = __webpack_public_path__ + "img/EAJ2.38d438a8.png";